import { render, staticRenderFns } from "./vocalist.vue?vue&type=template&id=9df34292&scoped=true"
import script from "./vocalist.vue?vue&type=script&lang=js"
export * from "./vocalist.vue?vue&type=script&lang=js"
import style0 from "./vocalist.vue?vue&type=style&index=0&id=9df34292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df34292",
  null
  
)

export default component.exports